var __jsx = React.createElement;
import React from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import useTranslation from '@/i18n/useTranslation';
import { CDN_LINK } from '@globalConfig';
var BenefitsComparison = function BenefitsComparison() {
  var lang = useLang();
  var isArabic = lang === 'ar';
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  var comparisonItems = [{
    benefit: tShort('benefits/benefit1', {
      ns: 'web_sell_trade'
    })
  }, {
    benefit: tShort('benefits/benefit2', {
      ns: 'web_sell_trade'
    })
  }, {
    benefit: tShort('benefits/benefit3', {
      ns: 'web_sell_trade'
    })
  }, {
    benefit: tShort('benefits/benefit4', {
      ns: 'web_sell_trade'
    })
  }, {
    benefit: tShort('benefits/benefit5', {
      ns: 'web_sell_trade'
    })
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "my-8 md:my-[71px] px-5 bg-[#F1F6FC] py-10 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-[1200px] mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[28px] font-bold text-[#3c56d4] text-center mb-6 md:text-[40px] md:mb-5"
  }, tShort('benefits/title', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[18px] font-medium text-[#8C9FB6] text-center mb-[51px] md:text-[24px] md:mb-8"
  }, tShort('benefits/subtitle', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement("div", {
    className: "max-w-full mx-auto md:max-w-[565px] md:relativeoverflow-x-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex bg-transparent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 py-4 px-0 text-[16px] font-semibold text-[#333] text-right ltr:text-left rtl:text-right"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 p-4  flex items-center justify-center  max-w-[68px] md:max-w-[108px] md:w-[108px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/sell-trade/Container@1.svg",
    width: 57,
    height: 26,
    alt: "Syarah",
    className: "m-auto align-middle"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 p-4 flex-row items-center py-2.5 px-2.5 text-[14px] font-bold text-center rounded-2 text-[#3c56d4] relative border border-[#3c56d4] line-height-24"
  }, /*#__PURE__*/React.createElement("div", null, tShort('benefits/traditional_column_title', {
    ns: 'web_sell_trade'
  }), /*#__PURE__*/React.createElement("br", null), tShort('benefits/traditional_column_sub', {
    ns: 'web_sell_trade'
  })))), comparisonItems.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex bg-transparent border-b border-solid border-gray-200 last:border-b-0",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-1 py-4 px-0 text-[16px] font-semibold text-[#333] text-right ltr:text-left rtl:text-right"
    }, item.benefit), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 p-4  flex items-center justify-center bg-[#E2FFE9] max-w-[68px] md:max-w-[108px] md:w-[108px]"
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/sell-trade/true-icon.svg",
      alt: "Yes",
      className: "w-7 h-7"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 p-4 flex items-center justify-center bg-transparent"
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/sell-trade/false-icon.svg",
      alt: "No",
      className: "w-7 h-7"
    })));
  }))));
};
export default BenefitsComparison;